const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

//Action to save and fetch data
import { fetchtopten, frontimmutable } from "../../actions/front_actions";

//Import Designs
import {
	Typography,
	Grid2,
	Card,
	CardContent,
	CardActions,
	Backdrop,
	CircularProgress,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteIcon from "@mui/icons-material/Favorite";
import StarIcon from "@mui/icons-material/Star";

import ContestantTitle from "./ContestantTitle.jsx";
import ContestantImage from "./ContestantImage.jsx";
import VideoContestant from "./VideoContestant.jsx";

class ToptenContestant extends Component {
	constructor(props) {
		super(props);
		this.state = { anchorEl: "", wait: 1 };
	}

	componentDidMount = () => {
		this.setState({ wait: 1 });
		this.props.fetchtopten(
			this.props.SITE_URL,
			this.props.short.id,
			this.props.short
		);
		setTimeout(
			function () {
				this.setState({ wait: 0 });
			}.bind(this),
			1000
		);
	};

	render() {
		const { wpvc_spacing, row_width } = this.props.settings.style;
		const { votes_button_bgcolor, votes_button_font_color } = this.props.settings.color;
		const xs_row = row_width;
		const posts = this.props.post.top_contestans;
		const allprops = this.props;
		const contest_type = this.props.short.contest_type;

		if (posts && this.state.wait != 1) {
			return (
				(<Grid2 container className="wpvc_showcontestant_container">
					<Grid2 container size={12} direction="row" spacing={parseInt(wpvc_spacing)} className="wpvc_show_style">
						{posts.map((object, i) => (
							<Grid2 key={i} className="wpvc_show_style_row" size={{ xs: 12, md: parseInt(xs_row) }}>
								<Card className="wpvc_card_row">
									<div className="wpvc_topten_card_media">
										{/* <ContestantImage {...allprops} singlepost={object} indexpost={i} view="topten" /> */}
										{contest_type != null &&
											(contest_type == "photo" || contest_type == "essay") && (
												<ContestantImage {...allprops} singlepost={object} indexpost={i} view="topten" />
											)}
										{contest_type != null &&
											(contest_type == "video" || contest_type == "music") && (
												<VideoContestant {...allprops} singlepost={object} indexpost={i} view="topten" />
											)}
										<div className="wpvc_icon_topten_star">
											<StarIcon />
											<span>{i + 1}</span>
										</div>
									</div>
									<CardContent className="wpvc_card_content_row wpvc_card_topten_title">
										<ContestantTitle hideCategory={1} {...allprops} post_single={posts} singlepost={object} view={this.props.view} />
									</CardContent>

									<CardActions style={{ padding: 0 }} className="wpvc_cardcontainer_topten">
										<Grid2 container size={12} justifyContent="space-between" style={{ background: votes_button_bgcolor, color: votes_button_font_color, padding: '10px' }}>
											<Grid2 className="wpvc_card_actions_topten">
												<FavoriteIcon />
												<Typography>{object.votes_count}</Typography>
											</Grid2>

											<Grid2 className="wpvc_card_actions_topten">
												<VisibilityIcon />
												<Typography >{object.votes_viewers}</Typography>
											</Grid2>
										</Grid2>
									</CardActions>
								</Card>
							</Grid2>
						))}
					</Grid2>
				</Grid2>)
			);
		} else {
			return (
				<Backdrop className="wpvc_back_loader" open={true}>
					<CircularProgress color="inherit" />
				</Backdrop>
			);
		}
	}
}

const settingstate = (state) => {
	return { post: state.wpvcfrontdata };
};

export default connect(settingstate, { frontimmutable, fetchtopten })(
	withTranslation("translations")(ToptenContestant)
);
